// import cn from "classnames";
import RUIcon from '@assets/icons/flags/ru.svg';
import TRIcon from '@assets/icons/flags/tr.svg';
import HKIcon from '@assets/icons/flags/hk.svg';
import CNIcon from '@assets/icons/flags/cn.svg';
import styles from './Flag.module.css';

interface FlagProps {
  countryCode: string;
}

const flags: Record<string, string> = {
  "HK": HKIcon,
  "CN": CNIcon,
  "RU": RUIcon,
  "TR": TRIcon,
};

const Flag: React.FC<FlagProps> = ({
  countryCode,
}) => {
  if (!flags[countryCode]) return null;
  return (
    <img
      className={styles.root}
      src={flags[countryCode]}
    />
  );
};

export default Flag;
